/**
 * Image unit abbreviations
 */
enum ImageUnit {
	DPI = "dpi"
}

export default ImageUnit;